// Shared upload rules (#12, ehr#321). Contact images + files are sent as base64 JSON. The cap and
// the allowed types come from @ehr/shared (the API checks the same, plus the file's content), so a
// file is turned away up front with a clear message instead of failing on the server.
import { FILE_MAX_BYTES, FILE_MAX_LABEL, fileUploadProblem } from '@ehr/shared';

/** Hard cap for any contact image / file upload (4.5 MB, ehr#321). */
export const MAX_UPLOAD_BYTES = FILE_MAX_BYTES;

/** File-picker `accept` + hint for contact IMAGE zones (ID / insurance cards). */
export const IMAGE_ACCEPT = 'image/jpeg,image/png,image/webp,image/gif';
export const IMAGE_HINT = `JPG, PNG, WebP or GIF · up to ${FILE_MAX_LABEL}`;

/** Hint for the general Files tab / New-Client attachments (ehr#321: documents, sheets, images). */
export const FILE_HINT = `Documents, spreadsheets or images · up to ${FILE_MAX_LABEL} per file`;

/** Human-readable size, e.g. "1.9 MB" / "129 KB". */
export const fmtFileSize = (bytes: number): string =>
  bytes >= 1024 * 1024
    ? `${(bytes / 1024 / 1024).toFixed(1)} MB`
    : `${Math.max(1, Math.round(bytes / 1024))} KB`;

/** Validate a picked file; returns an error message, or null when it's fine. */
export const uploadError = (file: File, imageOnly: boolean): string | null => {
  if (imageOnly && !/^image\/(jpeg|png|webp|gif)$/.test(file.type))
    return 'Please choose an image file (JPG, PNG, WebP or GIF).';
  if (file.size > MAX_UPLOAD_BYTES)
    return `That file is ${fmtFileSize(file.size)} — please use one under ${FILE_MAX_LABEL}.`;
  return fileUploadProblem(file, { imageOnly });
};
